import type { LocationsCounters } from '@core/locations-types';
import { createSingleEntityStore } from '@core/ngrx-legacy';

const { actions, selectors, reducer, namespace } =
  createSingleEntityStore<LocationsCounters>()('LocationsCounters');

export {
  selectors as LocationCountersSelectors,
  actions as LocationCountersActions,
  reducer as LocationCountersReducer,
  namespace as LocationCountersNamespace,
};
